import { render, staticRenderFns } from "./appNotificationManageEdit.vue?vue&type=template&id=0d188ac7&scoped=true"
import script from "./appNotificationManageEdit.vue?vue&type=script&lang=js"
export * from "./appNotificationManageEdit.vue?vue&type=script&lang=js"
import style0 from "./appNotificationManageEdit.vue?vue&type=style&index=0&id=0d188ac7&prod&lang=css"
import style1 from "./appNotificationManageEdit.vue?vue&type=style&index=1&id=0d188ac7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d188ac7",
  null
  
)

export default component.exports